/**
 * 商品接口
 */
import ormTransform from './ormTransform'
import env from '../env'
import { uniqBy } from '@dt/fe-utils/dist/lodash'
import axios from 'axios'
import { ddayjs, format } from '@dt/fe-utils'
import { storeMobx } from 'restaurant'
import { memberMobx } from '@mobxStore'

export default class ProductAPI {
  static _hackForMaxCnt (modifierGroups: IModifierGroup[]) {
    if (modifierGroups && modifierGroups.length) {
      modifierGroups.forEach(modifierGroup => {
        modifierGroup.maxCnt = modifierGroup.maxCnt || -1
        modifierGroup.modifiers.forEach(modifier => {
          modifier.maxCnt = modifier.maxCnt || 1
        })
      })
    }
  }
  /** 获取菜单餐品 */
  static getProduct (brandId: number) {
    const url = `${env.JMOBILE}/mall/product/getMallProductsV2`
    return axios.post(url, { brandId }).then((res: any) => {
      const products = res.result.length ? res.result : []
      const categories: any[] = []
      const categoryMap: { [categoryNo: string]: any } = {}
      const transProductData = ormTransform.clearKey(products, 'product').map((product: any) => {
        // 处理统计分类 (category是显示分类，statisticsCategory是统计分类)
        const sortInCategory = {}
        product.categories = product.categoryDetail ? product.categoryDetail.map((detail: any) => {
          sortInCategory[detail.productCategoryNo] = detail.sort
          return detail.productCategoryNo
        }) : []
        // 在显示分组的排序
        product.sortInCategory = sortInCategory
        product.statisticsCategoryNo = product.categoryNo
        delete product.categoryId
        delete product.categoryNo
        // console.log(product.categoryDetail, 'product.categoryDetail')
        if (product.categoryDetail) {
          product.categoryDetail.forEach((category: any) => {
            if (!categoryMap[category.productCategoryNo]) {
              categoryMap[category.productCategoryNo] = category
              categories.push({ no: category.productCategoryNo, id: category.productCategoryId, name: category.name, title: category.title, pic: category.pic, categorySort: category.categorySort || 0 })
            }
          })
        }
        // 处理把口味组 modifierGroup | undefined -> modifierGroups
        product.modifierGroups = product.modifierGroup || []
        product.scaleGroup = product.scaleGroup || { scales: [] }
        delete product.modifierGroup
        // 兼容老的口味规格数据
        this._hackForMaxCnt(product.modifierGroups)
        product.scaleGroup.scales.forEach((scale: any) => this._hackForMaxCnt(scale.modifierGroups))
        // 处理把过敏源 allergy -> allergys
        product.allergys = (product.allergy || []).map((item: any) => {
          item.id = item.id || item.productAllergyId
          return item
        })
        // 处理把标签 tag -> tags
        product.tags = (product.tag || []).map((item: any) => {
          item.id = item.id || item.productAllergyId
          return item
        })
        // 模拟先加入长宽
        if (product.pic) {
          const info = format.toPic(product.pic)
          product.picWidth = info.w || 100
          product.picHeight = info.h || 100
          // product.pics = product.pic
          try {
            product.pics = JSON.stringify(JSON.parse(product.pic).filter(item => !!item || !!item.url))
          } catch (e) {
            product.pics = JSON.stringify([{ url: product.pic, type: 'image', default: 1, w: null, h: null }])
          }
          product.pic = info.url
        } else {
          product.pic = ''
          product.picWidth = 0
          product.picHeight = 0
        }
        product.isCanTogo = product.isCanTogo === undefined || !!product.isCanTogo
        product.taxInPrice = !!product.taxInPrice
        product.isShowInMenu = product.showInMenu !== 0
        product.isSingleSale = product.isSingleSale !== 0
        product.isNotSingleInCombo = !product.noSell

        // 统计销量、购买人
        product.statSaleCnt = product.saleCnt
        product.statAvatar = product.avatar
        // 处理套餐
        if (product.group?.length) {
          product.productGroups = product.group.map((item: any) => {
            item.productGroupDetails = item.detailList.sort((d: any) => -d.sort)
            delete item.productGroupDetailList
            delete item.detailList
            return item
          })
        }
        delete product.group
        delete product.allergy
        delete product.tag
        delete product.categoryDetail
        /** 排序规格组 */
        // product.scaleGroup.scales.sort((a, b) => (b.sort || 9999) - (a.sort || 9999))
        /** 排序口味组 */
        product.modifierGroups.sort((a, b) => {
          a.modifiers.map((c, d) => (d.sort || 9999) - (c.sort || 9999))
          return a.index === 9999 ? (ddayjs(a.addTime).valueOf() - ddayjs(b.addTime).valueOf()) : (a.index - b.index)
        })
        // keep taxCategoryId
        product.taxCategoryId = product.taxCategoryId || 0
        /** 排序 */
        return product
      })
      // 在api层把默认排序处理完
      categories.sort((a, b) => b.categorySort - a.categorySort)
      categories.forEach(c => delete c.categorySort)
      return {
        products: uniqBy(transProductData, 'no'), // TODO 当前后端可能会返回异常的数据，这边做了过滤处理
        categories
      }
    })
  }
  /** 获取全部类别菜单餐品排序 */
  static getAllProducts () {
    const url = `${env.JMOBILE}/mall/product/getMallOnSaleSort2C`
    return axios.get(url).then((res: any) => {
      return (res && res.result && res.result.length && res.result[0].productNo) || []
    }).catch((err) => err)
  }
  /** 获取热搜餐品 */
  static getHotProduct (startTime: string, endTime: string, brandId: number) {
    const url = `${env.REPORT}/report/jl-pos-mall-rank/`
    const params = {
      params: {
        store_id: '0',
        start_time: startTime,
        end_time: endTime,
        brand_id: brandId
      },
    }
    return axios.post(url, params).then((res: any) => {
      return (res.result.content || []).map((v: any) => {
        return {
          qty: v.qty,
          no: v.product_no
        }
      })
    }).catch((err) => err)
  }
  /** 获取用户买过餐品 */
  static getBoughtProduct () {
    const url = `${env.POSMOBILE}/product/listProductBought`
    const params = {
      // storeId: storeMobx.info.storeId
    }
    return axios.get(url, { params }).then((res: any) => {
      return (res.result || []).map((v: any) => {
        return {
          no: v.productNo,
          cnt: v.orderCnt
        }
      })
    }).catch((err) => err)
  }
  /** 获取分组置顶商品 */
  static getBrandProductTop () {
    const url = `${env.JMOBILE}/mall/product/getBrandProductTopV2`
    return axios.get(url)
  }
  /** 获取收藏列表 */
  static getCollectList (params) {
    const url = `${env.MEMBER}/mall/collectList`
    return axios.get(url, { params })
  }
  /** 收藏商品 */
  static saveCollect (params) {
    const url = `${env.MEMBER}/mall/collect`
    return axios.post(url, params)
  }
  /** 取消收藏商品 */
  static deleteCollect (params) {
    const url = `${env.MEMBER}/mall/uncollect`
    return axios.post(url, params)
  }
  /** 获取商品详情关联推荐 */
  static getRecommendProduct (productNo: string) {
    const url = `${env.RECOMMEND}/recommend/cart`
    const params = {
      store_id: 0,
      brand_id: storeMobx.info.brandId,
      order_time: ddayjs().format('HH:mm'),
      member_id: memberMobx.memberInfo.memberId,
      cart: [productNo]
    }
    return axios.post(url, params).then((res: any) => {
      return res
    }).catch((err) => err)
  }
}
